import { render, staticRenderFns } from "./EditProductDetails.vue?vue&type=template&id=25551b0a&"
import script from "./EditProductDetails.vue?vue&type=script&lang=js&"
export * from "./EditProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports